import React from "react";

import { TextField } from "../TextField";
import { Grid } from "../../UI/Grid";
import { Modal } from "../Modal";
import { Button } from "../../UI/Button";
import Api from "../../services/Api";
import { useModalContext } from "../../contexts/ModalContext/context";
import useAuth from "../../routes/login/AuthContext";
import {
  useNetworkContext,
  useSelectedNetworkContext,
} from "../../contexts/NetworkContext/context";
import { GenderGroupSelect } from "./GenderGroupSelect";
import { useSnackbar } from "../../hooks/useSnackbar";

interface IProps {
  subnetwork: number;
}

export const AddGenderOptionModal: React.FC<IProps> = (props) => {
  const [genderName, setGenderName] = React.useState("");
  const [genderGroup, setGenderGroup] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);
  const { setIsOpen } = useModalContext();
  const { loadNetworkInfoForNetworks } = useNetworkContext();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { getAuthToken } = useAuth();

  const handleClose = () => setIsOpen(false);

  const handleAddGender = React.useCallback(async () => {
    setIsLoading(true);

    const res = await Api.setGender(
      selectedNetworkId,
      {
        genderName,
        groupId: genderGroup,
        l1Id: selectedNetworkId,
        l2Id: props.subnetwork,
      },
      await getAuthToken()
    );

    if (res.success) {
      showSuccessSnackbar("Saved Changes");
    } else {
      showErrorSnackbar("An Error Occurred");
    }

    await loadNetworkInfoForNetworks([selectedNetworkId]);

    handleClose();
    setIsLoading(false);
  }, [selectedNetworkId, props.subnetwork, genderGroup, genderName]);

  const handlGenderName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGenderName((event.target as HTMLInputElement).value);
  };

  const handlGenderGroup = async (value: number) => {
    setGenderGroup(value);
  };

  return (
    <Modal
      maxWidth="sm"
      title="Add Gender Option"
      containerSx={{
        overflow: "visible",
      }}
      contentSx={{
        overflow: "visible",
      }}
      actions={
        <>
          <Button appearance="subtle" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            appearance="primary"
            isLoading={isLoading}
            onClick={handleAddGender}
          >
            Add Gender Option
          </Button>
        </>
      }
    >
      <Grid container spacing={2} px={3} py={2} width={400}>
        <Grid item xs={12}>
          <TextField
            label="Gender Option"
            value={genderName}
            onChange={handlGenderName}
          />
        </Grid>
        <Grid item xs={12}>
          <GenderGroupSelect
            defaultValue={genderGroup}
            onChange={handlGenderGroup}
            subnetwork={props.subnetwork}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};
